module.exports = __webpack_public_path__ + "img/appltCourse-img2.d9860858.png";